<style scoped lang="scss">
.box {
  width: 100%;
  box-sizing: border-box;
  background: #f2f2f2;
  padding: 0 20px 20px 50px;

  .page_title {
    height: 50px;
    line-height: 50px;
    background: #ffffff;
    border-left: 10px solid #3399ff;
    font-size: 16px;
    font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
    color: #666666;
    font-weight: 700;
    padding-left: 15px;
  }
}
</style>
<template>
  <div
      class="box"
      element-loading-text="正在查询,请稍候..."
  >
    <p class="page_title">违章类型管理</p>

    <div class="">
      <el-form :model="query" ref="query" label-position="100px" size="mini" inline="true" style="" >
        <el-form-item label="类型名称" prop="checkDepartment">
          <el-input v-model="query.name" clearable></el-input>
        </el-form-item>
        <el-button type="primary" @click="fetchData">查询</el-button>
        <el-button @click="reset">重置</el-button>
        <el-button type="primary" @click="showAddDialog(null)">添加</el-button>
      </el-form>
    </div>
    <div class="table_box" style="padding-right: 10px">
      <el-table
          :data="data"
          border
          fit
          highlight-current-row
          :height="500"
          ref="table"
          size="mini"
          style="margin-top: 0px;">
        <el-table-column label="id" prop="id" width="105"/>
        <el-table-column label="违章类型名称" prop="name" width=""/>
        <el-table-column label="排序号" prop="sort"/>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="showUpdateDialog(scope.row)" >详情</el-button>
            <el-button type="text" size="mini" @click="remove(scope.row)" style="color: #f12">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageInfo.current"
          :page-sizes="[15, 50, 100, 200]"
          :page-size="pageInfo.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="text-align: right; margin-top: 10px;"/>

      <el-dialog :visible.sync="addDialogVisible" title="添加" top="20vh" width="1000px">
        <el-form ref="addStaffForm" :model="addForm" label-width="200px" style="max-height: 80vh; overflow-y: scroll; overflow-x: hidden; padding-right: 20px;" size="mini">
          <el-form-item label="类型名称(不能超过六个字符)"  required>
            <el-input v-model="addForm.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="排序号" required>
            <el-input-number v-model="addForm.sort" @change="handleChange" :min="0" :max="30" label="描述文字"></el-input-number>
          </el-form-item>
        </el-form>
        <div style="text-align: right; margin: 0; margin-top: 15px;">
          <el-button type="text" @click="addDialogVisible = false">取消</el-button>
          <el-button type="primary" size="" @click="add()">提交</el-button>
        </div>
      </el-dialog>

      <el-dialog :visible.sync="editDialogVisible" title="修改" top="20vh" width="1000px">
        <el-form ref="addStaffForm" :model="editForm" label-width="200px" style="max-height: 80vh; overflow-y: scroll; overflow-x: hidden; padding-right: 20px;" size="mini">
          <el-form-item label="类型名称(不能超过六个字符)"  required>
            <el-input v-model="editForm.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="排序号" required>
            <el-input-number v-model="editForm.sort" @change="handleChange" :min="0" :max="30" label="描述文字"></el-input-number>
          </el-form-item>
        </el-form>
        <div style="text-align: right; margin: 0; margin-top: 15px;">
          <el-button type="text" @click="editDialogVisible = false">取消</el-button>
          <el-button type="primary" size="" @click="update()">提交</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import request from '@/utils/apiRequest'

export default {
  data() {
    return {
      query: {
        name: '',
      },
      data: [],
      pageInfo: {
        current: 1,
        size: 15,
        total: 0
      },
      addDialogVisible: false,
      addForm: {},
      editDialogVisible: false,
      editForm: {},
    };
  },
  methods: {
    buildQueryForm() {
      const queryForm = {...this.query, ...this.pageInfo}
      delete queryForm.total
      return queryForm
    },
    fetchData() {
      const queryForm = this.buildQueryForm()
      queryForm.scope = 0
      request({
        url: '/user/violationType/listPage',
        params: queryForm,
        method: 'get'
      }).then(res => {
        this.data = res.data.records
        this.pageInfo.current = res.data.current
        this.pageInfo.size = res.data.size
        this.pageInfo.total = res.data.total
      })
    },
    handleSizeChange(size) {
      this.pageInfo.size = size
      this.fetchData()
    },
    handleCurrentChange(current) {
      this.pageInfo.current = current
      this.fetchData()
    },
    reset() {
      this.$refs.query.resetFields();
      this.query={}
      this.fetchData()
    },
    showAddDialog() {
      this.addForm = {}
      this.addForm = {
        score: 1,
        scope: 0,
      }
      this.addDialogVisible = true
    },
    add() {
      request({
        url: '/user/violationType/addOrUpdate',
        data: this.addForm,
        method: 'post',
        loading: true
      }).then(res => {
        this.addForm = {}
        this.addForm.score = 1
        this.addForm.scope = 0
        this.addDialogVisible = false
        this.fetchData()
        this.$message.success('操作成功')
      })
    },
    showUpdateDialog(editData) {
      this.editForm = {}
      this.editForm = editData
      this.editDialogVisible = true
    },
    update() {
      request({
        url: '/user/violationType/addOrUpdate',
        data: this.editForm,
        method: 'post',
        loading: true
      }).then(res => {
        this.editForm.score = 1
        this.editForm.scope = 0
        this.fetchData()
        this.$message.success('操作成功')
      })
    },
    remove(row) {
      this.$confirm('是否删除当前记录？删除后不可恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/user/violationType/remove',
          params: {
            id: row.id
          },
          method: 'get',
          loading: true
        }).then(res => {
          this.$message.success('操作成功')
          this.fetchData()
        })
      });
    },
  },
  mounted() {
    this.fetchData();
  }
};
</script>
